import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import H2HeaderText from '../ui/typography/H2HeaderText';
import BaseText from '../ui/typography/BaseText';
import CarouselCard from '../ui/cards/CarouselCard';
import FrenchTech from '../../images/homePageImages/frenchtech.png';
import Cyberport from '../../images/homePageImages/Cyberport.png';
import Google from '../../images/homePageImages/google.png';
import InvestHK from '../../images/homePageImages/investhk.png';
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};
export default function ReviewsCarousel({ carouselData, title, subtitle, bgColor, hideBelowImages }) {
  return (
    <section className={`${bgColor} py-28`}>
      <div className="global-max-width-wrapper mx-auto">
        <H2HeaderText textAlign="text-center" fontWeight="text-regular" title={title} />
        <BaseText
          textColor="text-gray-300"
          fontWeight="text-medium"
          textAlign="text-center"
          className="mt-2 mb-12"
          title={subtitle}
        />
        <Carousel
          swipeable={true}
          draggable={false}
          showDots={false}
          responsive={responsive}
          autoPlay={true}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlaySpeed={3000}
          keyBoardControl={true}
          customTransition="all .1"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={['tablet', 'mobile']}
          //   dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {carouselData.map((review) => (
            <CarouselCard review={review} />
          ))}
        </Carousel>
        {!hideBelowImages && (
          <div className="flex flex-col sm:flex-row gap-20 items-center justify-center mt-14">
            <img src={FrenchTech} alt="frenchtech-logo" width="87" height="87" loading="lazy" />
            <img src={Cyberport} alt="cyberport" width="149" height="107" loading="lazy" />
            <img src={Google} alt="google" width="83" height="27" loading="lazy" />
            <img src={InvestHK} alt="invest-hk" width="125" height="36" loading="lazy" />
          </div>
        )}
      </div>
    </section>
  );
}
